import { render, staticRenderFns } from "./StudentDetails.vue?vue&type=template&id=f8fe2be0&scoped=true"
import script from "./StudentDetails.vue?vue&type=script&lang=js"
export * from "./StudentDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8fe2be0",
  null
  
)

export default component.exports